module.exports = __webpack_public_path__ + "static/img/fengtian.807d5047.png";